import React, { useMemo } from "react";
import dayjs from "dayjs";
import {
  RadialBarChart,
  RadialBar,
  Legend,
  ResponsiveContainer,
} from "recharts";

const ExpiryRadialChart = ({ users = [] }) => {
  const data = useMemo(() => {
    if (!Array.isArray(users)) return [];

    const now = dayjs();

    let today = 0;
    let next3 = 0;
    let next7 = 0;

    users.forEach((u) => {
      if (!u?.end_date) return;

      const diff = dayjs(u.end_date).diff(now, "day");

      if (diff <= 1) today++;
      else if (diff <= 3) next3++;
      else if (diff <= 7) next7++;
    });

    return [
      { name: "Today", value: today, fill: "#ef4444" },
      { name: "3 Days", value: next3, fill: "#f59e0b" },
      { name: "7 Days", value: next7, fill: "#3b82f6" },
    ];
  }, [users]);

  return (
    <div style={{ width: "100%", height: 320 }}>
      <ResponsiveContainer>
        <RadialBarChart innerRadius="30%" outerRadius="100%" data={data}>
          <RadialBar dataKey="value" cornerRadius={8} />
          <Legend />
        </RadialBarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ExpiryRadialChart;
